import { useMemo } from 'react';
import { MapWhiteTG, DefaultG } from '../styles';
import { buildMap } from '../utility';
import { labels } from './labels';

//this is a test for fallback

const Labels = () => {
  const labelsContent = useMemo(
    () =>
      labels.map((data) => {
        switch (data.type) {
          case 'MapWhiteTG':
            return buildMap({ state: data, Element: MapWhiteTG });
          case 'g':
            return buildMap({ state: data, Element: DefaultG });
          default:
            return null;
        }
      }),
    [],
  );

  return <g id="labels">{labelsContent}</g>;
};

export default Labels;
